import React from "react";

const SvgOdemcene = props => (
  <svg viewBox="0 0 168 209" {...props}>
    <g data-name="Vrstva 2">
      <g data-name="Bo\u010Dn\xED menu">
        <path data-name="&lt;\u0158ez&gt;" fill="none" d="M0 0h168v209H0z" />
        <path d="M17.68 88a6.59 6.59 0 00-6.58 6.6v96.53a6.59 6.59 0 006.58 6.59H152.9a6.59 6.59 0 006.59-6.59V94.6a6.59 6.59 0 00-6.59-6.6zm67.61 20.2a19.61 19.61 0 0110.5 36.18v25.19a2.09 2.09 0 01-.25.74 10.31 10.31 0 01.25 1.23 10.5 10.5 0 11-21 0 8.65 8.65 0 01.25-1.23 2.09 2.09 0 01-.25-.74v-25.22a19.58 19.58 0 0110.49-36.14zM139.78 74.25a5 5 0 01-5-5A49.5 49.5 0 0039.69 50a5 5 0 01-9.21-3.9 59.49 59.49 0 01114.3 23.15 5 5 0 01-5 5z" />
        <path d="M139.78 123.87a5 5 0 01-5-5V69.25a5 5 0 0110 0v49.62a5 5 0 01-5 5z" />
      </g>
    </g>
  </svg>
);

export default SvgOdemcene;

